import type {
  Currency,
  ProductSalePriceInfo,
} from "@fero-shared/api-contracts";
import { create } from "zustand";

export interface PurchaserSalePriceStore {
  /**
   * A list of any "New" or "Updated" salePrice that the user has made changes to
   */
  salePricesToSave: ProductSalePriceInfo[];
  setSalePricesToSave: (salePrice: ProductSalePriceInfo[]) => void;

  salePricesToRemove: string[];
  setSalePricesToRemove: (productIds: string[]) => void;

  organisationId: string;
  setOrganisationId: (organisationId: string) => void;
  purchaserId: string;
  setPurchaserId: (purchaserId: string) => void;
  currency: Currency;
  setCurrency: (currency: Currency) => void;
  purchaserName: string;
  setPurchaserName: (purchaserName: string) => void;
  purchaserDiscount: string | null;
  setPurchaserDiscount: (discount: string | null) => void;
}

export const usePurchaserSalePriceStore = create<PurchaserSalePriceStore>(
  (set) => ({
    salePricesToSave: [],
    setSalePricesToSave: (salePrice) => {
      set({ salePricesToSave: salePrice });
    },
    organisationId: "",
    setOrganisationId: (organisationId) => {
      set({ organisationId });
    },
    purchaserId: "",
    setPurchaserId: (purchaserId) => {
      set({ purchaserId });
    },
    currency: "GBP",
    setCurrency: (currency) => {
      set({ currency });
    },
    purchaserName: "",
    setPurchaserName: (purchaserName) => {
      set({ purchaserName });
    },
    salePricesToRemove: [],
    setSalePricesToRemove: (productIds) => {
      set({ salePricesToRemove: productIds });
    },
    purchaserDiscount: "",
    setPurchaserDiscount: (purchaserDiscount) => {
      set({ purchaserDiscount: purchaserDiscount });
    },
  }),
);
